<template lang="html">
  <div class="bead" :class="{'bead-five': beadtype=='heavenly', 'bead-kid': kidColors, 'bead-five-kid': kidColors&&beadtype=='heavenly'}">

  </div>
</template>

<script>
export default {
  props: ['beadtype'],
  computed: {
    kidColors(){
      if (this.$store.getters['kids/gameMode']) {
        return true
      }else return false;
    },
  },
}
</script>

<style lang="scss" scoped>
.bead{
  width: 50px;
  height: 40px;
  border: 1px solid peru;
  border-radius: 30px;
  position: relative;
  width:50px;
  height:40px;
  background: linear-gradient(to bottom, sienna,maroon,sienna);
  clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);


  @media(max-width:600px){
    width: 28px;
    height: 28px;
    border-radius: 50%;
  }

  &.bead-kid{
    background: linear-gradient(to bottom, blue, mediumblue, blue);
  }
  &.bead-five-kid{
    background: linear-gradient(to bottom, green,darkgreen,green);
  }
}
</style>
